<template>
  <div id="LoadingPage" class="LoadingPage">
    <VueLoading :active.sync="isLoading || setting.isLoading"
                :loader="setting.loader"
                :is-full-page="setting.fullPage"
                :color="setting.color"
                :background-color="setting.bgColor"
                :opacity="setting.bgOpacity"
                :lock-scroll="setting.lockScroll"
                :z-index="setting.zIndex">
      <template slot="before"></template>
      <template slot="default">
        <div v-if="isCustomizeStyle" class="loadingio-spinner-rolling-wrap">
          <div class="animate">
            <div></div>
          </div>
        </div>
      </template>
      <template slot="after"></template>
    </VueLoading>
  </div>
</template>

<script>
// https://github.com/ankurk91/vue-loading-overlay/tree/v3.x
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'LoadingAnimate',
  props: {
    isLoading: {
      type: Boolean,
      default() {
        return false
      }
    },
    isFullPage: {
      type: Boolean,
      default() {
        return true
      }
    },
    bgColor: {
      type: String,
      default() {
        return '#000000'
      }
    },
    bgOpacity: {
      type: [String, Number],
      default() {
        return 0.5
      }
    }
  },
  data() {
    return {
      isCustomizeStyle: false, // 是否使用自定義樣式
      setting: {
        isLoading: false, // 載入狀態
        loader: 'dots', // 載入樣式 spinner or dots or bars
        fullPage: this.isFullPage, // 是否滿版 loading
        color: '#0fd',
        bgColor: this.bgColor,
        bgOpacity: this.bgOpacity, // 背景透明度
        lockScroll: true, // 顯示 loading 時凍結頁面捲軸
        zIndex: 9999
      }
    }
  },
  components: {
    VueLoading
  },
  mounted() {
    // 頁面載入loading
    // this.setting.isLoading = true
    // setTimeout(() => {
    //   this.setting.isLoading = false
    // }, 500)
  }
}
</script>

<style scoped></style>
